module.exports = __webpack_public_path__ + "img/reload.faa543a6.svg";